module.exports = __webpack_public_path__ + "static/media/1001028.5343558e.png";